import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { GraphqlResolverInput } from 'global';
import { useFormContext, useWatch } from 'react-hook-form';
import { Listing } from 'components/shared/TableListing';
import { DealActivityEventsListingInput, DealEventActivityViewModel } from '@trnsact/trnsact-shared-types';

import { BulkActions } from './BulkActions';
import { eventsListingColumns } from './eventsListingColumns';
import { EventListingRow, ListingFiltersValues } from './types';
import { calendarApi, DealActivityEventsListingQuery } from '../../api';

const toEventListingRow = (activity: DealEventActivityViewModel): EventListingRow => ({
  id: activity.id,
  type: activity.eventType,
  subject: activity.subject,
  due: activity.due ?? null,
  note: activity.notes ?? null,
  status: activity.activityStatus,
  account: activity.account.name ?? null,
});

export const EventsListing = () => {
  const [pagination, setPagination] = useState({ page: 1, perPage: 25 });

  const { control } = useFormContext<ListingFiltersValues>();
  const { search, ...filters } = useWatch({ control, name: 'filters' });

  const { loading, data, previousData } = useQuery<
    DealActivityEventsListingQuery,
    GraphqlResolverInput<DealActivityEventsListingInput>
  >(calendarApi.dealActivityEventsListing, {
    notifyOnNetworkStatusChange: true,
    variables: {
      input: {
        pagination,
        search,
        filters: {
          ...(filters.type.length ? { type: filters.type } : {}),
          ...(filters.status.length ? { status: filters.status } : {}),
          ...(filters.dateRange.from || filters.dateRange.to ? { dateRange: filters.dateRange } : {}),
        },
      },
    },
  });

  const items = data?.dealActivity?.result?.items ?? previousData?.dealActivity?.result?.items ?? [];
  const tableData = items.map(toEventListingRow);

  return (
    <Listing
      selection={{}}
      loading={loading}
      tableData={tableData}
      columns={eventsListingColumns}
      pagination={{
        ...pagination,
        total: data?.dealActivity?.result?.pagination?.total ?? 0,
        onChange: nextValue => setPagination(prev => ({ ...prev, page: nextValue })),
      }}
      bulkActions={({ selected }) => <BulkActions selectedIds={selected} />}
    />
  );
};
